<app-voucher
  *ngIf="printVoucher"
  [brand]="clientInformation"
  [details]="payment"
></app-voucher>

<div class="container container-margin">
  <div
    *ngIf="payment.cuotaBenefits === 0; else elseBlock"
    class="contenedor-payment"
  >
    <div class="contenedor-header-payment">
      <div class="contenedor-title">
        <h3>Compra aprobada por:</h3>
        <h3>
          {{ payment.amountFinance | currency : "USD" : "symbol" : "1.0-0" }}
        </h3>
      </div>

      <div class="print" (click)="print()">
        <mat-icon>print</mat-icon>
        <p>Imprimir boucher</p>
      </div>

      <div class="contenedor-imagen">
        <img
          src="../../../../../assets/img/pago-img.svg"
          alt="imagen de exitoso"
        />
      </div>
    </div>
    <div class="contenedor-subheader-payment">
      <div class="contenedor-texto">
        <p>No Crédito</p>
        <p>{{ payment.numCredit }}</p>
      </div>
    </div>
    <div class="contenedor-body-payment">
      <div class="contenedor-texto">
        <p class="title">Pago mínimo mensual</p>
        <p class="title">
          {{ payment.minPaid | currency : "USD" : "symbol" : "1.0-0" }}
        </p>
      </div>
      <div class="contenedor-texto">
        <p>Fecha límite de pago</p>
        <p>{{ datePaid }}</p>
      </div>
      <div class="contenedor-texto">
        <p>Número de cuotas</p>
        <p>{{ payment.fees }}</p>
      </div>
      <div class="contenedor-texto">
        <p>Interés anual</p>
        <p>{{ payment.rateApprobeAnnual }}% E.A.</p>
      </div>
    </div>

    <div class="contenedor-footer-payment">
      <div class="contenedor-texto">
        <p>Interés mensual</p>
        <p>{{ payment.rateApprobeMonth }}% M.V.</p>
      </div>

      <div class="contenedor-texto">
        <p>Fianza FGA</p>
        <p>{{ payment.fGA | currency : "USD" : "symbol" : "1.0-0" }}</p>
      </div>

      <div class="contenedor-texto">
        <p class="title">Tarifa de firma digital</p>
        <p class="title">
          {{ payment.signature | currency : "USD" : "symbol" : "1.0-0" }}
        </p>
      </div>

      <div class="contenedor-texto">
        <p class="title">Cuota de manejo</p>
        <p class="title">
          {{ payment.handlingFee | currency : "USD" : "symbol" : "1.0-0" }}
        </p>
      </div>

      <div class="contenedor-texto">
        <p class="title">Seguro de vida</p>
        <p class="title">
          {{ payment.insurance | currency : "USD" : "symbol" : "1.0-0" }}
        </p>
      </div>

      <button class="btn btn-azul btn-redondo" (click)="finish()">
        Finalizar
      </button>
    </div>
  </div>

  <ng-template #elseBlock>
    <div class="contenedor-payment">
      <div class="contenedor-header-payment">
        <div class="contenedor-title">
          <h3>Compra aprobada por:</h3>
          <h3>
            {{ payment.amountFinance | currency : "USD" : "symbol" : "1.0-0" }}
          </h3>
        </div>
        <div class="print" (click)="print()">
          <mat-icon>print</mat-icon>
          <p>Imprimir boucher</p>
        </div>
        <div class="contenedor-imagen">
          <img
            src="../../../../../assets/img/pago-img.svg"
            alt="imagen de exitoso"
          />
        </div>
      </div>
      <div class="contenedor-subheader-payment">
        <div class="contenedor-texto">
          <p>No Crédito</p>
          <p>{{ payment.numCredit }}</p>
        </div>
        <div class="contenedor-texto">
          <p>Interés anual</p>
          <p>{{ payment.rateApprobeAnnual }}% E.A.</p>
        </div>
        <div class="contenedor-texto">
          <p>Fianza FGA</p>
          <p>{{ payment.fGA | currency : "USD" : "symbol" : "1.0-0" }}</p>
        </div>

        <div class="contenedor-texto">
          <p class="title">Tarifa de firma digital</p>
          <p class="title">
            {{ payment.signature | currency : "USD" : "symbol" : "1.0-0" }}
          </p>
        </div>

        <div class="contenedor-texto">
          <p class="title">Cuota de manejo</p>
          <p class="title">
            {{ payment.handlingFee | currency : "USD" : "symbol" : "1.0-0" }}
          </p>
        </div>

        <div class="contenedor-texto">
          <p class="title">Seguro vida deudor</p>
          <p class="title">
            {{ payment.insurance | currency : "USD" : "symbol" : "1.0-0" }}
          </p>
        </div>
      </div>
      <div class="contenedor-body-payment">
        <div class="contenedor-texto">
          <p>Fecha límite de pago</p>
          <p>{{ datePaid }}</p>
        </div>
        <div class="contenedor-texto">
          <p class="title">Número de cuotas</p>
          <p class="title">{{ payment.fees }}</p>
        </div>

        <div class="contenedor-texto borde-azul">
          <p *ngIf="payment.fees > payment.feesBenefits">
            Descuento especial en las <b>{{ payment.feesBenefits }}</b> primeras
            cuotas gracias a <b>{{ partnerName }}</b>
          </p>
          <p *ngIf="payment.fees <= payment.feesBenefits">
            Descuento especial en tus cuotas gracias a
            <b>{{ partnerName }}</b>
          </p>
        </div>
      </div>

      <div class="contenedor-footer-payment">
        <div class="contenedor-beneficios">
          <div *ngIf="payment.cuotaBenefits !== 0.0" class="contenedor-texto">
            <p>1ra cuota <b>con</b> beneficio</p>
            <p>
              {{
                payment.cuotaBenefits | currency : "USD" : "symbol" : "1.0-0"
              }}
            </p>
          </div>
          <div *ngIf="payment.paid !== '0.0'" class="contenedor-texto">
            <p>*Cuotas <b>sin</b> beneficio</p>
            <p>{{ payment.paid | currency : "USD" : "symbol" : "1.0-0" }}</p>
            <p class="w-100 fuente-pequena">
              *Valor de la cuota que debes pagar a partir de la cuota
              <b>#{{ payment.feesBenefits + 1 }}</b
              >.
            </p>
          </div>
        </div>
        <button class="btn btn-azul btn-redondo" (click)="finish()">
          Finalizar
        </button>
      </div>
    </div>
  </ng-template>
</div>
